import { BaseOne } from '@cnx-saas/common';

export type PackagingParentFull = {
  packaging?: PackagingBase;
  quantityChildrenPerParent: number;
};

export type PackagingParentRef = {
  packagingCode: string;
  quantityChildrenPerParent: number;
};

export type PackageDimensions = {
  /** in kilograms */
  weight: number;
  /** in millimeters */
  height: number;
  /** in millimeters */
  width: number;
  /** in millimeters */
  length: number;
};

export type PackagingBase = {
  packagingCode: string;
  packagingDescription?: string;
  articlesPerPackage: number;
  maxStackSize: number;
  dimensions: PackageDimensions;
  liftingSide?: LiftingSide;
};

export type PackagingInput = PackagingBase & {
  parentInput?: PackagingParentRef;
};

export type Packaging = PackagingBase & {
  parent?: PackagingParentFull;
};

export type Package = BaseOne & Packaging & { tenantId: string };

export enum LiftingSide {
  Length = 'Length',
  Width = 'Width',
  Both = 'Both',
}
